/** 날짜(Asia/Seoul) `YYYY-MM-DD` */
export function todayKstIso(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

/**
 * 마지막 접속 표기: 마지막 로그인 시각보다 이후 날짜에 이용 기록이 있으면 날짜만,
 * 아니면 마지막 로그인 날짜·시각.
 */
export function formatLastAccess(
  lastSignInAt: string | null | undefined,
  lastActiveOn: string | null | undefined
): string {
  const activeOn = (lastActiveOn ?? '').trim().slice(0, 10);
  const signIn = lastSignInAt ? new Date(lastSignInAt) : null;
  const signInValid = signIn != null && !Number.isNaN(signIn.getTime());
  const signInDay = signInValid ? todayKstIso(signIn) : '';

  if (activeOn && (!signInDay || activeOn > signInDay)) {
    const [y, m, d] = activeOn.split('-').map(Number);
    if (y && m && d) {
      return new Date(y, m - 1, d).toLocaleDateString('ko-KR', { dateStyle: 'medium' });
    }
    return activeOn;
  }
  if (!signInValid) return lastSignInAt ? String(lastSignInAt) : '—';
  return signIn.toLocaleString('ko-KR', { dateStyle: 'medium', timeStyle: 'short' });
}
